<template>
  <div class="field-wrapper textarea-wrapper label-animate">
    <textarea
        :id="`field-${id}`"
        ref="field"
        v-model="textarea"
        v-validate="validate"
        :name="name"
        :class="textareaClass"
        maxlength="255"
        @keyup="onInput"
        @blur="blurValidate"
    />
    <label :for="`field-${id}`" class="animated-label">{{ label }}</label>
    <span v-if="error" class="error-message">{{ errorMessage }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, required: false, default: null },
    validate: { type: String, required: false, default: null },
    label: { type: String, required: true },
    name: { type: String, required: true },
    errorMessage: { type: String, default: null },
  },
  data() {
    return {
      textarea: this.value,
      hasValue: false,
      id: null,
      error: false,
    };
  },
  computed: {
    textareaClass() {
      return {
        'error': this.error,
        'has-value': this.hasValue,
      };
    },
  },
  mounted() {
    this.id = this._uid;
  },
  methods: {
    blurValidate() {
      this.error = !this.fields[this.name].valid;
    },
    isValid() {
      const { valid } = this.fields[this.name];
      return valid;
    },
    onInput(event) {
      const { value } = event.target;
      this.hasValue = value.length > 0;
      this.$emit('input', this.textarea);
    },
  },
};
</script>
